module.exports = __webpack_public_path__ + "static/media/sort-amount-up-alt.917678f4.svg";